<template>
    <div class="details_box">
      <div class="crumbs" @click="$router.push('/product')"><span style="color: #666666" >当前位置：产品中心></span> <span style="color: #666666">品牌产品></span> <span style="color: #666666">{{ ProductInfo.group_name }}></span> <span>{{ ProductInfo.name }}</span> </div>
      <div class="box_img">
        <div class="detais_banner">
          <swiper class="swiper" :options="swiperOption" v-if="ProductInfo.image && ProductInfo.image.length>0">
            <swiper-slide v-for="(item,index) in ProductInfo.image" :key="index">
              <img :src="ProductInfo.image[0]">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="details_infos">
            <div class="box_img_ouy">
              <div class="details_name">{{ProductInfo.name}}</div>
              <div class="details_group">分类：{{ProductInfo.group_name}}</div>
              <div class="explain">
                <div class="titles">说明：</div>
                <div class="info_caser one-txt-line">{{ProductInfo.intro}}</div>
              </div>
              <div class="explain aty">
                <div class="titles">规格：</div>
                <div class="info_caser one-txt-line tr">{{ProductInfo.spec}}</div>
                <div class="titles">包装：</div>
                <div class="info_caser one-txt-line">{{ProductInfo.pack}}</div>
              </div>
              <div class="btns_ouy">招商热线：{{ config.hotline_tel }}</div>
            </div>
        </div>
      </div>
      <div class="info_txt">
        <div class="tiname">
          <div class="info_txt_care">产品说明</div>
          <div class="line"></div>
        </div>
        <div class="info_details">
          <div class="box_html" v-html="ProductInfo.text"></div>
        </div>
      </div>
    </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import {getConfig, getProductInfo} from "../../api/apis";
import 'swiper/dist/css/swiper.css'
export default {
name: "Details" ,
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      ProductInfo:{},
      config:{}
    }
  },
  mounted() {
    this.GetConfig()
      if(this.$route.query.detaisId){
        this.detaisId = this.$route.query.detaisId
      }
      this.GetProductInfo()

  },
  methods:{
    GetConfig() {
      getConfig().then(res => {
        this.config = res.data
      })
    },
    GetProductInfo(){
      let datas = {id:this.detaisId}
      getProductInfo(datas).then(res=>{
        res.data.text = res.data.text.replace(/\<img/gi, '<img style="max-width:100%;height:auto"')
        this.ProductInfo = res.data
      })
    },
  }
}
</script>

<style scoped lang="less">
    .details_box{
       width: 100%;

      .crumbs{
        padding: 30px 0 15px;
        border-bottom: 1px solid #DBDBDB;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0092DD;
        opacity: 1;
        margin-bottom: 40px;
      }
      .box_img{
          min-height: 424px;
          display: flex;
          .detais_banner{
             width: 50%;
             height: 100%;
            .swiper {
              position: relative;
              height: 424px;
              transition: all 0.3s linear;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
          .details_infos{
            width: 50%;
            background: #F8F8F8;
            .box_img_ouy{
              padding: 25px 47px 40px;
              .details_name{
                font-size: 30px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #0092DD;
              }
              .details_group{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                margin: 10px 0 25px;
              }
              .explain{
                padding:16px 30px 23px;
                display: flex;
                align-items: center;
                background: #FFFFFF;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                margin-bottom: 12px;
                .titles{
                  //margin-right: 30px;
                }
                .info_caser{
                  height: 52px;
                  background: #FFFFFF;
                  border: 1px solid #F0F0F0;
                  line-height: 52px;
                  padding:0 27px;
                }
                .tr{
                  margin-right: 36px;
                }
              }
              .aty{
                padding: 12px 30px;
              }
              .btns_ouy{
                height: 43px;
                background: #0092DD;
                opacity: 1;
                border-radius: 22px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 43px;
                color: #FFFFFF;
                text-align: center;
                margin-top: 40px;
              }
            }
          }
        }
      .info_txt{
        margin-top: 60px;
        margin-bottom: 160px;
        .tiname{
          width: 120px;
          margin: 0 auto 40px;
          text-align: center;
          .info_txt_care{
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          .line{
            width: 62px;
            height: 3px;
            background: #555555;
            margin: 10px auto 0;
          }
        }
        .info_details{
          background: #F8F8F8;
          box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
          opacity: 1;
          padding: 16px 13px;
          .box_html{
            width: 100%;
          }
        }
      }
    }
    @media (max-width: 1200px) {
      .details_box{

        .crumbs{
          padding: 15px 0 7px;
          border-bottom: 1px solid #DBDBDB;
          font-size: 10px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #0092DD;
          opacity: 1;
          margin-bottom: 15px;
        }
        .box_img{
          min-height: auto;
          display: flex;
          flex-wrap: wrap;
          .detais_banner{
            width: 100%;
            height: 100%;
            .swiper {
              position: relative;
              height: 243px;
              transition: all 0.3s linear;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
          .details_infos{
            width: 100%;
            background: #F8F8F8;
            .box_img_ouy{
              padding: 15px 27px 23px;
              .details_name{
                font-size: 17px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #0092DD;
              }
              .details_group{
                font-size: 10px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                margin: 5px 0 15px;
              }
              .explain{
                padding:10px 18px 13px;
                display: flex;
                align-items: center;
                background: #FFFFFF;
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                margin-bottom: 7px;
                .titles{
                  width: 45px;
                  margin-right: 12px;
                }
                .info_caser{
                  height: 23px;
                  background: #FFFFFF;
                  border: 1px solid #F0F0F0;
                  line-height: 23px;
                  padding:0 9px;
                }
                .tr{
                  margin-right:21px;
                }
              }
              .aty{
                padding: 8px 18px;
              }
              .btns_ouy{
                height: 25px;
                background: #0092DD;
                opacity: 1;
                border-radius: 11px;
                font-size: 11px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 25px;
                color: #FFFFFF;
                text-align: center;
                margin-top: 23px;
              }
            }
          }
        }
        .info_txt{
          margin-top: 31px;
          margin-bottom:65px;
          .tiname{
            width: 120px;
            margin: 0 auto 23px;
            text-align: center;
            .info_txt_care{
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #666666;
            }
            .line{
              width: 31px;
              height: 2px;
              background: #555555;
              margin: 5px auto 0;
            }
          }
          .info_details{
            background: #F8F8F8;
            box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
            opacity: 1;
            padding: 5px 4px;
            .box_html{
              width: 100%;
            }
          }
        }
      }
    }
</style>
<style lang="less">
  .details_box{
    .swiper-pagination{
      bottom: 34px;
      .swiper-pagination-bullet{
        width: 23px;
        height: 8px;
        background: #000000;
        opacity: 0.1;
        border-radius: 30px;
      }
      .swiper-pagination-bullet-active{
        background: #0092DD;
        opacity: 1;
      }
    }
  }
</style>